import { Link } from 'react-router';
import { Column, Row, Spinner, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { OutlineArrowRightIcon } from '@tempmee/react-icons';
import { EmptyScreen, Pagination } from '~/commonComponents';
import { EmptyShiftPendingReview } from '~/images/icons';
import { Table } from './components/Table';
import { usePendingShiftReviews } from './hooks';

interface IProps {
  isCompact?: boolean;
}

export const ShiftPendingReviews = ({ isCompact = false }: IProps) => {
  const { data, isInitialLoading, isLoading, page, total, onPageChanged } = usePendingShiftReviews({
    limit: isCompact ? 5 : 10,
  });

  if (isInitialLoading) {
    return (
      <Row align="center" justify="center" style={{ width: '100%', flex: 1, minHeight: 300 }}>
        <Spinner />
      </Row>
    );
  }

  if (data.length === 0 && !isLoading) {
    return (
      <Column style={{ paddingBottom: 64 }}>
        <EmptyScreen
          Icon={() => <EmptyShiftPendingReview />}
          title="You're all caught up!"
          description="All shift confirmations and adjustments are up to date. We'll update this after your next shift ends."
          descriptionStyle={{ textAlign: 'center' }}
        />
      </Column>
    );
  }

  return (
    <Column>
      <Table data={data} isLoading={isLoading} />
      {isCompact ? (
        <Link
          to="/dashboard/jobs/pending-reviews"
          style={{ textDecoration: 'none', cursor: 'pointer', marginRight: 12 }}
        >
          <Row align="center" justify="end" style={{ gap: 14, paddingBottom: 16, paddingTop: 24 }}>
            <Typography bold color={colors.secondary[500]}>
              View All
            </Typography>
            <OutlineArrowRightIcon width={24} height={24} />
          </Row>
        </Link>
      ) : (
        <Row justify="center" style={{ paddingBlock: 24 }}>
          <Pagination
            currentPage={page}
            onPageChange={onPageChanged}
            totalPages={Math.ceil(total / (isCompact ? 5 : 10))}
          />
        </Row>
      )}
    </Column>
  );
};
